import { runbookLabel } from '../../telas/painel-p1/tela8-adapter';

import { ModalBase } from './ModalBase';

import type React from 'react';

export interface RunbookModalProps {
  open: boolean;
  /** Slug canônico resolvido por categoria (D3) ou o massivo (D7). */
  slug: string | null;
  /** Texto de desfecho vindo da resposta do servidor (executionId/status). */
  outcome?: string | null;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmação de acionamento de runbook — converte modals-3.jsx (RunbookModal).
 * Diferente do protótipo (config hard-coded csam/massivo), aqui é dirigido pelo
 * SLUG real resolvido; o texto de desfecho vem da RESPOSTA do servidor (R1-R9).
 */
export function RunbookModal({
  open,
  slug,
  outcome,
  isPending,
  onClose,
  onConfirm,
}: RunbookModalProps): React.JSX.Element | null {
  if (slug === null) return null;
  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title={`Acionar ${runbookLabel(slug)}`}
      width={580}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className="btn-ghost-mini" type="button" onClick={onClose} disabled={isPending}>
            Cancelar
          </button>
          <button
            className="btn-ghost-mini btn-ghost-mini--primary"
            type="button"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? 'Acionando…' : 'Acionar runbook'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <div className="modal-form__callout modal-form__callout--danger">
          ⚠ Ação sensível — o runbook executa um protocolo de resposta a incidente crítico
          (notificações, registros forenses e tarefas automatizadas). Confirme apenas se este P1 o
          exige.
        </div>
        <div>
          <div className="modal-form__label">Runbook</div>
          <span className="mono">{slug}</span>
        </div>
        {outcome != null && (
          <div className="modal-form__callout" role="status">
            {outcome}
          </div>
        )}
      </div>
    </ModalBase>
  );
}
